<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="handleRoleEdit(true, null)"
          >新增角色</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="权限名"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleAddPower(scope.row)"
              >分配权限</el-button
            >
            <el-button type="text" @click="handleRoleEdit(false, scope.row)"
              >修改</el-button
            >
            <el-button type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :page-count="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="roleEditVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="roleForm"
        :model="role_form"
        :rules="role_rules"
        label-width="120px"
      >
        <el-form-item label="名称：" prop="name">
          <el-input v-model="role_form.name" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="权限名：" prop="remark">
          <el-input v-model="role_form.remark" @input="onInput()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveRoleEdit('roleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="menuVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-tree
          :data="menus"
          show-checkbox
          node-key="id"
          ref="treeMenus"
          :default-expanded-keys="menu_expanded_keys"
          :default-checked-keys="menu_checked_keys"
          :props="defaultProps"
        ></el-tree>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="handleConfirmMenu">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/manageApiConfig";
export default {
  name: "Rolemanage",
  data() {
    return {
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      page_index: 0,
      role_id: "",
      loading: false,
      is_add: false,
      roleEditVisible: false,
      role_form: {},
      role_rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
      },
      select_role_id: "",
      menus: [],
      menuVisible: false,
      defaultProps: {
        children: "sub_menu",
        label: "title",
      },
      menu_expanded_keys: [],
      menu_checked_keys: [],
    };
  },
  created() {
    let that = this;
    that.getData();
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      http.get("admin/roles", { params: params }).then(function(res) {
        that.tableData = res.data.data.roles;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.loading = false;
      });
    },
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          let params = {
            role_id: row.id,
          };
          http.delete("admin/role", { params: params }).then(function(res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleRoleEdit(add, row) {
      this.is_add = add;
      if (add) {
        this.role_form = {
          name: "",
          remark: "",
        };
      } else {
        this.role_form = {
          role_id: row.id,
          name: row.name,
          remark: row.remark,
        };
      }
      this.roleEditVisible = true;
    },
    saveRoleEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            name: that.role_form.name,
            remark: that.role_form.remark,
          };
          if (that.is_add) {
            http.post("admin/role", params).then(function(res) {
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              }
            });
          } else {
            params["role_id"] = that.role_form.role_id;
            http.put("admin/role", params).then(function(res) {
              if (res.data.status_code == 200) {
                that.$message.success(`修改成功`);
                that.getData();
              }
            });
          }
          that.roleEditVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAddPower(row) {
      let that = this;
      that.menu_checked_keys = [];
      http.get("admin/menus").then(function(res) {
        that.menus = res.data;
        setTimeout(() => {
          that.select_role_id = row.id;
          let params = {
            role_id: row.id,
          };
          http.get("admin/menus", { params: params }).then((res) => {
            let menus = res.data;
            setTimeout(() => {
              that.flattenMenus(menus);
              setTimeout(() => {
                let selectId = that.menu_checked_keys; //权限id当前拥有 [1,2,3]
                that.$nextTick(() => {
                  selectId.forEach((item) => {
                    const node = that.$refs["treeMenus"].getNode(item); //根据id获取对应node节点
                    if (node?.isLeaf) {
                      //isLeaf 这个属性意思是如果是叶子节点就是true,然后可以根据这个设置回显，那么他父节点会默认半选或者全选根据叶子节点
                      that.$refs["treeMenus"].setChecked(node, true);
                    }
                  });
                });
              }, 50);
              that.menuVisible = true;
            }, 80);
          });
        }, 100);
      });
    },
    // 递归处理树形结构
    flattenMenus(menus) {
      for (const menu of menus) {
        this.menu_checked_keys.push(menu.id); // 将当前菜单的id添加到数组中
        if (menu.sub_menu && menu.sub_menu.length > 0) {
          this.flattenMenus(menu.sub_menu); // 递归处理子菜单
        }
      }
    },
    handleConfirmMenu() {
      let that = this;
      let menu_nodes = that.$refs.treeMenus.getCheckedKeys();
      let menu_half_nodes = that.$refs.treeMenus.getHalfCheckedKeys();
      if (menu_nodes.length > 0) {
        menu_nodes = menu_nodes.concat(menu_half_nodes);
        menu_nodes = _.uniq(menu_nodes);
        let params = {
            role_id: that.select_role_id,
            menu_ids: menu_nodes.join(',')
        }
        http.post("admin/role_menu", params).then(function(res) {
            if (res.data.status_code == 200) {
                that.$message.success(`分配成功`);
                that.getData();
                that.menuVisible = false;
            }
        });
      } else {
        that.$message.warning("请最少选择一项");
      }
    },
  },
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
</style>
